<template>
  <div class="so-no-selector">
    <el-tooltip placement="bottom-end">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <el-input v-model="firstLineVal" :disabled="disabled" :readonly="true" />
    </el-tooltip>
    <span class="el-button el-button--primary el-button--mini" style="margin-left:2px;width: 45px;min-width: 45px;" @click="showDialog = true">...</span>
    <!-- 多行输入对话框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="showDialog"
      :title="$t('SeaExport.SelectSoNo')"
      width="450px"
      :show-close="false"
      class="app-main-inner"
    >
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px"
        @gridReady="params=>{gridApi=params.api}"
      />
      <span slot="footer" style="padding:10px">
        <div style="float:right">
          <el-button v-if="!disabled" type="primary" @click="save">{{ $t('common.btn.confirm') }}</el-button>
          <span v-if="disabled" class="el-button el-button--mini" @click="showDialog=false">{{ $t('common.btn.close') }}</span>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import StrUtils from '@/utils/StrUtils'

export default {
  name: 'SoNoSelector',
  components: { },
  props: {
    soNo: { type: String, required: true },
    value: { type: String, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerValue: '',
      firstLineVal: '',
      showDialog: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        rowHeight: 32,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      soNos: '',
      selectedSoNos: '',
      checkBoxVisible: false,
      tooltip: '',
      columnDefs: [{
        headerName: '',
        field: '',
        width: 65,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        resizable: false
      },
      {
        headerName: 'S/O No.',
        field: 'soNo',
        width: 264
      }]
    }
  },
  watch: {
    value(newVal) {
      this.checkBoxVisible = !this.disabled
      this.innerValue = newVal
      this.tooltip = newVal.replace(/\n/g, '<br/>')
      this.toRowData()
    },
    showDialog(newVal) {
      if (!newVal) {
        this.save()
      } else {
        this.toRowData()
      }
    },
    disabled(val) {
      if (this.gridParams && this.gridParams.columnApi) {
        const columnState = this.gridParams.columnApi.getColumnState()
        columnState[0].hide = val
        this.gridParams.columnApi.setColumnState(columnState)
      }
    }
  },
  created() {
    if (this.soNo) {
      this.toRowData()
    }
  },
  methods: {
    toRowData() {
      const rowData = []
      this.selectedSoNos = []
      this.firstLineVal = ''
      // 查看状态下不显示 checkbox
      if (this.disabled) {
        this.selectedSoNos = StrUtils.isEmpty(this.value) ? [] : this.value.split('\n')
        for (const soNo of this.selectedSoNos) {
          rowData.push({ isSelect: true, soNo: soNo })
        }
      } else {
        this.soNos = StrUtils.isEmpty(this.soNo) ? [] : this.soNo.split('\n')
        this.selectedSoNos = StrUtils.isEmpty(this.value) ? [] : this.value.split('\n')
        for (const soNo of this.soNos) {
          const isSelect = this.isExist(this.selectedSoNos, soNo)
          if (!StrUtils.isEmpty(soNo.trim())) { rowData.push({ isSelect: isSelect, soNo: soNo }) }
        }
      }
      this.firstLineVal = this.selectedSoNos.length > 0 ? this.selectedSoNos[0] : ''
      this.rowData = rowData
      this.$nextTick(() => {
        this.setGridSelect()
      })
    },
    isExist(r, s) {
      let exist = false
      for (const str of r) {
        if (str === s) {
          exist = true
          break
        }
      }
      return exist
    },
    setGridSelect() {
      if (!this.gridApi) return
      const nodes = this.gridApi.getRenderedNodes()
      if (!nodes) {
        return
      }
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        if (item.data.isSelect) {
          item.setSelected(true)
        }
      }
    },
    save() {
      if (this.disabled) {
        this.showDialog = false
        return
      }
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$emit('input', '')
        this.showDialog = false
        return
      }
      this.firstLineVal = rows[0].soNo
      this.innerValue = Array.from(rows, p => p.soNo).reduce((a, b) => a + '\n' + b)
      this.$emit('input', this.innerValue)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss">
.so-no-selector {
  display: flex;
  flex-direction: row;
}
</style>
